<template>
    <el-container id="tab">
        <el-aside class="aside-box" :width="isCollapse ? '20px' : '320px'">
            <el-card v-show="!isCollapse" shadow="never">
                <el-tabs v-model="activeName" type="card">
                    <el-tab-pane label="查询条件" name="query">
                        <el-form label-width="80px" :model="queryForm" ref="queryFormRef" status-icon>
                            <el-scrollbar>
                                <el-form-item label="单据类型" prop="billType.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.billType.selected" clearable placeholder="请选择">
                                        <el-option label="销售单" value="A"></el-option>
                                        <el-option label="还货单" value="B"></el-option>
                                        <el-option label="退货单" value="C"></el-option>
                                        <el-option label="换货单" value="D"></el-option>
                                        <el-option v-if="isOpenPromotionSale" label="访销单" value="E"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="单据日期" prop="billDate.selected">
                                    <date-picker style="width: 100%;" v-model="queryForm.billDate.selected" type="daterange"
                                        align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                                        end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                                    </date-picker>
                                </el-form-item>
                                <el-form-item label="大类" prop="brand.selected">
                                    <select-multiple style="width: 100%;" v-bind:select-data="queryForm.brand"
                                        :change="brandChange"></select-multiple>
                                </el-form-item>
                                <el-form-item label="小类" prop="brandType.selected">
                                    <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.brandType"></select-multiple>
                                </el-form-item>
                                <el-form-item label="商品" prop="product.selected">
                                    <el-select class="select_multiple" ref="productSelectRef" style="width: 100%;"
                                        v-model="queryForm.product.selected" value-key="value" multiple clearable
                                        placeholder="请选择商品名称" @click.native="productInputFocus">
                                        <el-option v-for="item in queryForm.product.list" :key="item.value"
                                            :label="item.text" :value="item"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="品牌" prop="financialBrand.selected">
                                    <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.financialBrand"></select-multiple>
                                </el-form-item>
                                <el-form-item label="所属片区" prop="domainDesc.selected">
                                    <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.domainDesc"></select-multiple>
                                </el-form-item>
                                <el-form-item label="客户" prop="customer.selected">
                                    <!-- <select-multiple style="width: 100%;" v-bind:select-data="queryForm.customer"></select-multiple> -->
                                    <el-select style="width: 100%;" class="select_multiple query_form_item" ref="customerSelectRef"
                                        v-model="queryForm.customer.selected" value-key="value" multiple clearable
                                        placeholder="请选择客户名称" @click.native="customerInputFocus">
                                        <el-option v-for="item in queryForm.customer.list" :key="item.value"
                                            :label="item.text" :value="item"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="业务员" prop="salesman.selected">
                                    <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.salesman"></select-multiple>
                                </el-form-item>
                                <el-form-item label="配送员" prop="deliverUser.selected">
                                    <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.deliverUser"></select-multiple>
                                </el-form-item>
                                <el-form-item label="所属公司" prop="subCompanyID.selected" v-if="!isSettlementCustomer">
                                    <select-multiple style="width: 100%;" :select-data="queryForm.subCompanyID"
                                        is-scroll></select-multiple>
                                </el-form-item>
                                <el-form-item label="结算单位" prop="settlementCustomerId.selected" v-if="isSettlementCustomer">
                                    <select-multiple :select-data="queryForm.settlementCustomerId" key="settlementCustomerId"></select-multiple>
                                </el-form-item>
                                <el-form-item label="客户类别" prop="customerTypes.selected">
                                    <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.customerTypes"></select-multiple>
                                </el-form-item>
                                <el-form-item label="客户标签" prop="label.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.label.selected" filterable multiple value-key="id" placeholder="请选择客户标签">
                                        <el-option v-for="item in queryForm.label.list" :key="item.id" :label="item.labelDesc" :value="item">
                                        <span>{{ item.labelDesc }}({{ item.shortName }})</span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="服务员工" prop="serviceUserId.selected">
                                    <select-multiple style="width: 100%;" v-bind:select-data="queryForm.serviceUserId"></select-multiple>
                                </el-form-item>
                                <el-form-item label="建档人" prop="entryUserId.selected">
                                    <select-multiple style="width: 100%;" v-bind:select-data="queryForm.entryUserId"></select-multiple>
                                </el-form-item>
                                <el-form-item label="客户等级" prop="customerLevel.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.customerLevel.selected" clearable placeholder="请选择">
                                        <el-option label="A类客户" value="A"></el-option>
                                        <el-option label="B类客户" value="B"></el-option>
                                        <el-option label="C类客户" value="C"></el-option>
                                        <el-option label="D类客户" value="D"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="客户状态" prop="customerStatus.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.customerStatus.selected" clearable placeholder="请选择">
                                        <el-option label="正常" value="Y"></el-option>
                                        <el-option label="作废" value="N"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="是否新店" prop="isNewShop.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.isNewShop.selected" clearable placeholder="请选择">
                                        <el-option label="是" value="Y"></el-option>
                                        <el-option label="否" value="N"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="新成交客户" prop="isNewCustomer.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.isNewCustomer.selected" clearable placeholder="请选择">
                                        <el-option label="是" value="Y"></el-option>
                                        <el-option label="否" value="N"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="商品类型" prop="productLabelIds.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.productLabelIds.selected" filterable multiple value-key="value" placeholder="请选择商品类型">
                                        <el-option v-for="item in queryForm.productLabelIds.list" :key="item.value" :label="item.text" :value="item"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="商品优先级" prop="productClassification.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.productClassification.selected" clearable placeholder="请选择">
                                        <el-option label="A级" value="A"></el-option>
                                        <el-option label="B级" value="B"></el-option>
                                        <el-option label="C级" value="C"></el-option>
                                        <el-option label="D级" value="D"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="商品包装" prop="isScatterProduct.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.isScatterProduct.selected" clearable placeholder="请选择">
                                        <el-option label="定量" value="A"></el-option>
                                        <el-option label="散称包装" value="B"></el-option>
                                        <el-option label="散称裸货" value="C"></el-option>
                                        <el-option label="散称干果" value="D"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="价格带" prop="priceBandLabelId.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.priceBandLabelId.selected" filterable multiple value-key="value" placeholder="请选择价格带">
                                        <el-option v-for="item in queryForm.priceBandLabelId.list" :key="item.value" :label="item.text" :value="item"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="是否为物料" prop="isMaterial.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.isMaterial.selected" clearable placeholder="请选择">
                                        <el-option label="是" value="Y"></el-option>
                                        <el-option label="否" value="N"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="是否统计缸数" prop="countTankStats.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.countTankStats.selected" clearable placeholder="请选择">
                                        <el-option label="是" value="Y"></el-option>
                                        <el-option label="否" value="N"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="供应商" prop="supplierID.selected">
                                    <select-multiple style="width: 100%;" :select-data="queryForm.supplierID"></select-multiple>
                                </el-form-item>
                                <el-form-item label="销售形式" prop="isLargess.selected">
                                    <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.isLargess"></select-multiple>
                                </el-form-item>
                                <el-form-item label="退货原因" prop="causeId.selected">
                                    <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.causeId"></select-multiple>
                                </el-form-item>
                                <el-form-item label="部门" prop="departmentID.selected">
                                    <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.departmentID"></select-multiple>
                                </el-form-item>
                                <el-form-item label="库房" prop="warehouseID.selected">
                                    <select-multiple style="width: 100%;"
                                        v-bind:select-data="queryForm.warehouseID"></select-multiple>
                                </el-form-item>
                                <el-form-item label="是否新品" prop="isNewProduct.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.isNewProduct.selected" clearable placeholder="请选择">
                                        <el-option label="是" value="Y"></el-option>
                                        <el-option label="否" value="N"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="是否车销" prop="isFromVehicle.selected">
                                    <el-select style="width: 100%;" v-model="queryForm.isFromVehicle.selected" clearable placeholder="请选择">
                                        <el-option label="是" value="Y"></el-option>
                                        <el-option label="否" value="N"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="整单备注" prop="remark.selected">
                                    <el-input placeholder="请输入整单备注" v-model.trim="queryForm.remark.selected" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="单品备注" prop="detailRemark.selected">
                                    <el-input placeholder="请输入单品备注" v-model.trim="queryForm.detailRemark.selected" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="清欠情况" prop="arrearType.selected">
                                    <el-select style="width: 100%;" v-if="!isSettlementCustomer" v-model="queryForm.arrearType.selected" multiple clearable placeholder="请选择">
                                        <el-option key="A" label="现结" value="A"></el-option>
                                        <el-option key="B" label="已清欠" value="B"></el-option>
                                        <el-option key="C" label="未清欠" value="C"></el-option>
                                    </el-select>
                                    <el-select style="width: 100%;" v-if="isSettlementCustomer" v-model="queryForm.arrearType.selected" multiple clearable placeholder="请选择">
                                        <el-option key="A" label="现结" value="A"></el-option>
                                        <el-option key="B" label="已清欠" value="B"></el-option>
                                        <el-option key="C" label="未清欠未对账" value="C"></el-option>
                                        <el-option key="D" label="未清欠已对账" value="D"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-scrollbar>
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit">查询</el-button>
                                <el-button @click="onReset">重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
                <el-button style="position: absolute; top: 11px;right: 20px; padding: 0; font-size: 15px;"
                    icon="el-icon-d-arrow-left" type="text" @click="isCollapse = !isCollapse"></el-button>
            </el-card>
            <div class="isCollapse" v-show="isCollapse" @click="isCollapse = !isCollapse">
                <span style="text-align: center;">查询</span>
                <el-button icon="el-icon-d-arrow-right" type="text"></el-button>
                <span style="text-align: center;">条件</span>
            </div>
        </el-aside>
        <el-main class="main-box">
            <el-tabs type="border-card" v-model="tabsName" class="tabs-card">
                <el-card shadow="never" style="position: relative;">
                    <el-form :inline="true" style="height: 41px; overflow-y: auto; width: calc(100% - 70px);">
                        <el-form-item style="position: absolute; top: 5px; right: 12px;">
                            <!-- <el-button type="success" size="medium" style="margin-right: 6px;"
                                @click="exportExcel">导出</el-button>
                            <el-button type="success" size="medium" style="margin-right: 6px;"
                                @click="exportExcel('Y')">拆分导出</el-button> -->
                                <el-dropdown @command="handleCommand">
                                    <el-button size="medium" type="primary">
                                        导出<i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="A">导出</el-dropdown-item>
                                        <el-dropdown-item command="B">拆分导出</el-dropdown-item>
                                        <el-dropdown-item command="C">金蝶导出</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                        </el-form-item>
                    </el-form>
                </el-card>
                <el-tab-pane label="销售明细表" :name="tabsName">
                    <!-- :summary-method="getSummaries" -->
                    <el-table border v-loading="loadingTable" :ref="tag" :data="tableList" height="100%" max-height="100%" :show-summary="true" :summary-method="getSummaries" @row-dblclick="jumpDetails">
                        <el-table-column type="index" align="center" width="40" fixed>
                            <template slot="header">
                                <el-tooltip slot="reference" class="item" effect="dark" content="设置隐藏列(点击显示/隐藏)"
                                    placement="top">
                                    <el-button icon="el-icon-s-tools" type="text" @click="getCustomColumns"></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column></el-table-column> -->
                        <template v-for="item in tableHeaderList">
                            <template>
                              <el-table-column :key="item.id" :label="item.label" :prop="item.prop" :width="item.width" v-if="item.isShow == 'Y' && item.allowCostPrice != 'N'">
                                <template slot-scope="scope">
                                    <div v-if="item.prop == 'totalSalQty'">{{ scope.row.totalSalQtyFormat }}</div>
                                    <div v-else-if="item.prop == 'totalMidQty'">{{ scope.row.totalMidQtyFormat }}</div>
                                    <div v-else-if="item.prop == 'totalInvQty'">{{ scope.row.totalInvQtyFormat }}</div>
                                    <div v-else>{{scope.row[item.prop]}}</div>
                                </template>
                              </el-table-column>
                            </template>
                        </template>
                    </el-table>
                </el-tab-pane>

            </el-tabs>
            <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="params.page" :page-sizes="[10, 20, 100]" :page-size="params.size"
                layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>

        </el-main>
        <el-dialog title="自定义显示列" v-if="dialogVisible" :visible.sync="dialogVisible" :close-on-click-modal="false" width="20%">
            <customizeColumns
                ref="customColumns"
                :checkboxList="checkboxList"
                :tableHeaderList="tableHeaderList"
                :draggable="true"
                @changeChecked="changeChecked"
                @confirm="dialogClose">
            </customizeColumns>
        </el-dialog>
    </el-container>
</template>
<script>
import datePicker from '@/components/common/datePicker.vue' 
// import customColumns from '@/components/common/customColumns.vue'
import customizeColumns from '@/components/common/customizeColumns.vue'
import { pickerOptions, getNowFormatDate, getAddDate, exportExcelCommonForVue } from '@/assets/js/common.js'
export default {
    name: "commodityDetails",
    components: {
        datePicker,
        // customColumns,
        customizeColumns
    },
    props: ['type', 'timestemp'],
    computed: {
        customColumnList() {
            let tempItem = {}
            this.checkboxList.forEach(i => {
                tempItem[i.prop] = (i.isShow == 'Y')
            })
            return tempItem
        }
    },
    data() {
        return {
            // 自定义列
            checkboxList: [
                { "id": 1, "prop":"helpCode", "label": '客户助记码', 'isShow': "Y" },
                { "id": 2, "prop":"boss", "label": '客户联系人', 'isShow': "N"},
                { "id": 3, "prop":"phoneNumber", "label": '客户电话', "isShow": "N"},
                { "id": 4, "prop":"address", "label": '客户地址', "isShow": "N"},
                { "id": 5, "prop":"itemCode", "label": '商品编码', "isShow": "N"},
                { "id": 6, "prop":"itemSpec", "label": '规格', "isShow": "N"},
                { "id": 7, "prop":"financialBrandName", "label": '品牌', "isShow": "N"},
                { "id": 8, "prop":"brandName", "label": '大类', "isShow": "N"},
                { "id": 9, "prop":"itemTypeName", "label": '小类', "isShow": "N"},
                { "id": 10, "prop":"description", "label": '口味', "isShow": "N"},
                { "id": 11, "prop":"invItemCode", "label": '口味小单位条码', "isShow": "N"},
                { "id": 12,"prop":"midItemCode", "label": '口味中单位条码', "isShow": "N"},
                { "id": 13,"prop":"salItemCode", "label": '口味大单位条码', "isShow": "N"},
                { "id": 14,"prop":"priceFormat", "label": '单价', "isShow": "N"},
                { "id": 15,"prop":"totalSalQty", "label": '折算大单位数量', "isShow": "N"},
                { "id": 16,"prop":"totalMidQty", "label": '折算中单位数量', "isShow": "N"},
                { "id": 17,"prop":"totalInvQty", "label": '小单位数量', "isShow": "N"},
                { "id": 18,"prop":"salPrice", "label": '大单位标准价', "isShow": "N"},
                { "id": 19,"prop":"price", "label": '小单位标准价', "isShow": "N"},
                { "id": 20,"prop":"salBillPrice", "label": '大单位结算价', "isShow": "N"}, 
                { "id": 21,"prop":"midBillPrice", "label": '中单位结算价', "isShow": "N"},
                { "id": 22,"prop":"salLevelPrice", "label": '大单位等级价', "isShow": "N"},
                { "id": 23,"prop":"midLevelPrice", "label": '中单位等级价', "isShow": "N"},
                { "id": 24,"prop":"billPrice", "label": '小单位结算价', "isShow": "N"},
                { "id": 25,"prop":"levelPrice", "label": '小单位等级价', "isShow": "N"},
                { "id": 26, "prop": "diffPrice", "label": '差价（结算价-等级价）', "isShow": "N" },
                { "id": 27, "prop": "totalDiffPrice", "label": '总差价（结算价-等级价）', "isShow": "N" },
                { "id": 28, "prop": "chaJiaDesc", "label": '差价（结算价-标准价）', "isShow": "N" },
                { "id": 29, "prop": "chaJiaTotalDesc", "label": '总差价（结算价-标准价）', "isShow": "N" },
                { "id": 30,"prop":"invCostPrice", "label": '小单位成本价', "isShow": "N"},
                { "id": 31,"prop":"itemCostPrice", "label": '大单位成本价', "isShow": "N"},
                { "id": 32,"prop":"costPrice", "label": '成本总价', "isShow": "N"},
                { "id": 33,"prop":"payAmt", "label": '实付金额', "isShow": "N"},
                { "id": 34,"prop":"arrearType", "label": '清欠情况', "isShow": "N"},
                { "id": 35,"prop":"itemWeight", "label": '总重量(Kg)', "isShow": "N"},
                { "id": 36,"prop":"itemWeightTon", "label": '总重量(吨)', "isShow": "N"},
                { "id": 37,"prop":"profitAmt", "label": '毛利', "isShow": "N"},
                { "id": 38,"prop":"salProfitAmtLv", "label": '销售毛利率', "isShow": "N"},
                { "id": 39,"prop":"costProfitAmtLv", "label": '成本毛利率', "isShow": "N"},
                { "id": 40,"prop":"deliverUserName", "label": '配送员', "isShow": "N"},
                { "id": 41,"prop":"entryUserName", "label": '制单人', "isShow": "N"},
                { "id": 42,"prop":"entryDateTime", "label": '制单时间', "isShow": "N"},
                { "id": 43,"prop":"recordedUserName", "label": '审核人', "isShow": "N"},
                { "id": 44,"prop":"recordedDateTime", "label": '审核时间', "isShow": "N"},
                { "id": 45,"prop":"productionDate", "label": '生产日期', "isShow": "N"},
                { "id": 46,"prop":"orderBillNo", "label": '订单单号', "isShow": "N"},
                { "id": 47,"prop":"detailRemark", "label": '单品备注', "isShow": "N"},
                { "id": 48,"prop":"remark", "label": '整单备注', "isShow": "N"}
            ],
            tag: 'tab',
            //左边
            activeName: 'query',
            value: true,
            isCollapse: false,
            pickerOptions: pickerOptions,
            queryForm: {
                billDate: { submitName: 'billDate', selected: [getAddDate(-3), getNowFormatDate()] },
                product: { submitName: 'itemID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择商品名称', request: { url: '/Account/itemMasterDefine/selectItemMastForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                departmentID: { submitName: 'departmentID', selected: [],valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false,isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择部门', request: { url: '/Account/departmentDefine/selectDepartmentDownListForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: ''}},
                brand: { submitName: 'brandID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择大类', request: { url: '/Account/dataSearch/selectBrandListForVue.html', type: 'post', params: { page: 1, size: 5, isPage: 'Y' }, text: '', value: '' } },
                financialBrand: { submitName: 'financialBrandID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择品牌', request: { url: 'Account/dataSearch/selectFinanceBrandListForVue.html', type: 'post', params: { page: 1, size: 5, isEnabled: 'Y' }, text: '', value: '' } },
                brandType: { submitName: 'itemTypeID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: true, list: [], placeholder: '请选择小类', request: { url: '/Account/dataSearch/selectTypeListNewForVue.html', type: 'post', params: { page: 1, size: 5, isPage: 'Y' }, text: '', value: '' } },
                salesman: { submitName: 'salesmanID', selected: [],valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择业务员', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 5, isFitterEnabled: 'N' }, text: '', value: '' } },
                deliverUser: { submitName: 'deliverUserID', selected: [],valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择配送员', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 5, isFitterEnabled: 'N' }, text: '', value: '' } },
                domainDesc: { submitName: 'domainID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择所属片区', request: { url: '/Account/domainDefine/getDomainListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                subCompanyID: { submitName: 'subCompanyID', selected: [],valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: true, list: [], label: 'label', value: 'value', placeholder: '请选择所属公司', request: { url: '/Account/customerDefineVue/selectChainStoresList.html', type: 'post', params: { page: 1, size: 10 }, text: '', value: '' } },
                settlementCustomerId: { submitName: 'settlementCustomerId', selected: [],valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], label: 'text', value: 'value', placeholder: '请选择结算单位', request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                customer: { submitName: 'customerID', valueIsObj: true, selected: [], isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户', request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                customerTypes: { submitName: 'classifyID', selected: [], valueIsObj: true,isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户类别', request: { url: '/Account/customerTypeDefine/getCustomerTypesForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                isLargess: { submitName: 'isLargess', selected: [],valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择销售形式', request: { url: '/Account/salSaleType/querySalSaleList.html', type: 'post', params: { page: 1, size: 100, isPage: 'N' }, text: '', value: '' } },
                causeId: { submitName: 'causeId', selected: [],valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: false, isReSearch: false, list: [], placeholder: '请选择退货原因', request: { url: '/Account/returnCaseDefine/selectReturnCaseNew.html', type: 'post', params: { }, text: '', value: '' } },
                warehouseID: { submitName: 'warehouseID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll:false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择仓库', request: { url: '/Account/wareHouseDefine/selectWarehouseForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: '' }},
                billType: { submitName: 'billType', selected: [] },
                isNewProduct: { submitName: 'isNewProduct', selected: [] },
                isFromVehicle: { submitName: 'isFromVehicle', selected: [] },
                remark: { submitName: 'remark', selected: '' },
                detailRemark: { submitName: 'detailRemark', selected: '' },
                arrearType: { submitName: 'arrearType', selected: [] },
                label: { submitName: 'label', selected: [], list: [], valueIsObj: true},
                // ==================== 客户/商品维度查询条件（需求#154） ====================
                serviceUserId: { submitName: 'serviceUserId', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择服务员工', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 5, isFitterEnabled: 'N' }, text: '', value: '' } },
                entryUserId: { submitName: 'entryUserId', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择建档人', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 5, isFitterEnabled: 'N' }, text: '', value: '' } },
                customerLevel: { submitName: 'customerLevel', selected: '' },
                customerStatus: { submitName: 'customerStatus', selected: '' },
                isNewShop: { submitName: 'isNewShop', selected: '' },
                isNewCustomer: { submitName: 'isNewCustomer', selected: '' },
                productLabelIds: { submitName: 'productLabelIds', selected: [], list: [], valueIsObj: true, isMultiple: true, placeholder: '请选择商品类型' },
                productClassification: { submitName: 'productClassification', selected: '' },
                isScatterProduct: { submitName: 'isScatterProduct', selected: '' },
                priceBandLabelId: { submitName: 'priceBandLabelId', selected: [], list: [], valueIsObj: true, isMultiple: true, placeholder: '请选择价格带' },
                isMaterial: { submitName: 'isMaterial', selected: '' },
                countTankStats: { submitName: 'countTankStats', selected: '' },
                supplierID: { submitName: 'supplierID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], label: 'text', value: 'value', placeholder: '请选择供应商', request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: { page: 1, size: 5, customerType: 'V' }, text: '', value: '' } }
            },
            salesman: '全部',
            params: {
                beginDate: getAddDate(-3),
                endDate: getNowFormatDate(),
                page: 1,
                size: 20,
                url: '/erpnew/account/c/reada46ceb/sale/collect/selectSaleCollectList.html',
            },
            makeUpIndex: null,
            //右边
            tabsName: '销售统计详情',
            tabsIndex: 0,
            allowCostPrice: 'N',
            priceArgs: {
                url: "/Account/dataSearchVue/getUserAllowCostPrice.html",
                code: 'isSaleReport'
            },
            dialogVisible: false,
            summaries: {},
            tableColumnList: [],
            selectList: [],
            tableHeaderList: [
                { label: '单据类型', prop: 'billTypeName',isShow: 'Y', width: 130 },
                { label: '单据日期', prop: 'billDate',isShow: 'Y', width: 130 },
                { label: '仓库', prop: 'warehouseName',isShow: 'Y', width: 150 },
                { label: '客户', prop: 'customerName',isShow: 'Y', width: 150 },
                { label: '片区', prop: 'domainDesc',isShow: 'Y', width: 150 },
                { label: '客户编码', prop: 'customerCode', isShow: 'N', width: 150 },
                { label: '客户助记码', prop: 'helpCode', isShow: 'N', width: 150 },
                { label: '客户联系人', prop: 'boss',isShow: 'N', width: 150 },
                { label: '客户电话', prop: 'phoneNumber',isShow: 'N', width: 150 },
                { label: '客户地址', prop: 'address',isShow: 'N', width: 180 },
                { label: '商品', prop: 'itemName',isShow: 'Y', width: 150 },
                { label: '商品编码', prop: 'itemCode',isShow: 'N', width: 150 },
                { label: '规格', prop: 'itemSpec',isShow: 'N', width: 150 },
                { label: '品牌', prop: 'financialBrandName',isShow: 'N', width: 150 },
                { label: '大类', prop: 'brandName',isShow: 'N', width: 150 },
                { label: '小类', prop: 'itemTypeName',isShow: 'N', width: 150 },
                { label: '口味', prop: 'description',isShow: 'N', width: 150 },
                { label: '口味小单位条码', prop: 'invItemCode',isShow: 'N', width: 150 },
                { label: '口味中单位条码', prop: 'midItemCode',isShow: 'N', width: 150 },
                { label: '口味大单位条码', prop: 'salItemCode',isShow: 'N', width: 150 },
                { label: '小单位条码', prop: 'invBarCode',isShow: 'N', width: 150 },
                { label: '中单位条码', prop: 'midBarCode',isShow: 'N', width: 150 },
                { label: '大单位条码', prop: 'salBarCode',isShow: 'N', width: 150 },
                { label: '销售形式', prop: 'isLargessName',isShow: 'Y', width: 150 },
                { label: '数量', prop: 'qtyFormat',isShow: 'Y', width: 150 },
                { label: '单价', prop: 'priceFormat', isShow: 'Y', width: 150 },
                { "prop": "totalSalQty", "label": '大单位数量', "isShow": "N", width: 150 },
                { "prop": "totalMidQty", "label": '中单位数量', "isShow": "N", width: 150 },
                { label: '小单位数量', prop: 'totalInvQty', isShow: 'N', width: 150 },
                { "prop": "salPrice", "label": '大单位标准价', "isShow": "N", width: 150 },
                { "prop": "price", "label": '小单位标准价', "isShow": "N", width: 150 },
                // { label: '小单位单价', prop: 'price',isShow: 'N', width: 150 },
                { label: '大单位结算价', prop: 'salBillPrice',isShow: 'N', width: 150 },
                { label: '中单位结算价', prop: 'midBillPrice',isShow: 'N', width: 150 },
                { label: '大单位等级价', prop: 'salLevelPrice',isShow: 'N', width: 150 },
                { label: '中单位等级价', prop: 'midLevelPrice',isShow: 'N', width: 150 },
                { label: '小单位结算价', prop: 'billPrice',isShow: 'N', width: 150 },
                { label: '小单位等级价', prop: 'levelPrice',isShow: 'N', width: 150 },
                { label: '差价（结算价-等级价）', prop: 'diffPrice',isShow: 'N', width: 180 },
                { label: '总差价（结算价-等级价）', prop: 'totalDiffPrice',isShow: 'N', width: 200 },
                { label: '差价（结算价-标准价）', prop: 'chaJiaDesc',isShow: 'N', width: 180 },
                { label: '总差价（结算价-标准价）', prop: 'chaJiaTotalDesc',isShow: 'N', width: 200 },
                { label: '小单位成本价', prop: 'invCostPrice',isShow: 'N', width: 150, allowCostPrice: 'N' },
                { label: '大单位成本价', prop: 'itemCostPrice',isShow: 'N', width: 150, allowCostPrice: 'N' },
                { label: '成本总价', prop: 'costPrice',isShow: 'N', width: 150, allowCostPrice: 'N' },
                { label: '实付金额', prop: 'payAmt',isShow: 'N', width: 150 },
                { label: '清欠情况', prop: 'arrearType',isShow: 'N', width: 150 },
                { label: '总金额', prop: 'totalAmt',isShow: 'Y', width: 150 },
                { label: '总重量(Kg)', prop: 'itemWeight',isShow: 'N', width: 150 },
                { label: '总重量(吨)', prop: 'itemWeightTon',isShow: 'N', width: 150 },
                { label: '毛利', prop: 'profitAmt',isShow: 'N', width: 150, allowCostPrice: 'N' },
                { label: '销售毛利率', prop: 'salProfitAmtLv',isShow: 'N', width: 150, allowCostPrice: 'N' },
                { label: '成本毛利率', prop: 'costProfitAmtLv',isShow: 'N', width: 150, allowCostPrice: 'N' },
                { label: '业务员', prop: 'salesmanName',isShow: 'Y', width: 150 },
                { label: '配送员', prop: 'deliverUserName',isShow: 'N', width: 150 },
                { label: '制单人', prop: 'entryUserName',isShow: 'N', width: 150 },
                { label: '制单时间', prop: 'entryDateTime',isShow: 'N', width: 180 },
                { label: '审核人', prop: 'recordedUserName',isShow: 'N', width: 150 },
                { label: '审核时间', prop: 'recordedDateTime',isShow: 'Y', width: 180 },
                { label: '生产日期', prop: 'productionDate',isShow: 'Y', width: 150 },
                { label: '单号', prop: 'billNo',isShow: 'Y', width: 200 },
                { label: '订单单号', prop: 'orderBillNo',isShow: 'Y', width: 200 },
                { label: '单品备注', prop: 'detailRemark',isShow: 'Y', width: 150 },
                { label: '整单备注', prop: 'remark',isShow: 'N', width: 150 },
                // ==================== 客户/商品维度列表列（需求#154，默认隐藏） ====================
                { label: '服务员工', prop: 'serviceUserName', isShow: 'N', width: 150 },
                { label: '建档人', prop: 'customerEntryUserName', isShow: 'N', width: 150 },
                { label: '客户等级', prop: 'customerLevel', isShow: 'N', width: 150 },
                { label: '客户标签', prop: 'customerLabel', isShow: 'N', width: 150 },
                { label: '结算单位', prop: 'settlementCustomerName', isShow: 'N', width: 150 },
                { label: '新成交客户', prop: 'isNewCustomerName', isShow: 'N', width: 150 },
                { label: '是否新店', prop: 'isNewShopName', isShow: 'N', width: 150 },
                { label: '客户状态', prop: 'customerStatus', isShow: 'N', width: 150 },
                { label: '商品类型', prop: 'productLabelName', isShow: 'N', width: 150 },
                { label: '商品优先级', prop: 'productClassification', isShow: 'N', width: 150 },
                { label: '商品包装', prop: 'isScatterProductName', isShow: 'N', width: 150 },
                { label: '价格带', prop: 'priceBandLabelName', isShow: 'N', width: 150 },
                { label: '是否为物料', prop: 'isMaterialName', isShow: 'N', width: 150 },
                { label: '是否统计缸数', prop: 'countTankStatsName', isShow: 'N', width: 150 },
                { label: '供应商', prop: 'supplierName', isShow: 'N', width: 150 }
            ],
            //弹窗
            selectProductVisible: false,
            tableList: [
            ],
            total: 0,
            selectLabelList: [],
            customColumn: [],
            // 上一级页面的 查询条件
            previousParams: {},
            isSettlementCustomer: false, // 是否开启结算单位
            loadingTable: false,
            isOpenPromotionSale: false
        }
    },
    created() {
        let unwatch = this.$watch('$store.state.power', (val) => {
            this.allowCostPrice = this.$store.state.power.allowCostPrice
            this.isSettlementCustomer = this.$store.state.power.isSettlementCustomer == 'Y'
            this.isOpenPromotionSale = this.$store.state.power.isOpenPromotionSale == 'Y'
            if(val.enterpriseVersion >= 100){
                this.getPriceShow()
            }else {
                this.getCustomColumnsList()
            }
            unwatch()
        })
        this.getLabelData()
    },
    mounted() {
        console.log('mounted')
        console.log(this.type)
        window.top.addEventListener('message', this.messageOfSelectoneself)
        // 如果type为true 说明上层双击过来的  需要监听设置查询参数  查询
        if(this.type) {
            console.log('上级传参')
            // window.top.addEventListener('message', this.messageOfSelect)
            this.queryQueryDataTemp()
        } else {
            console.log('自身调用')
            this.getTableList()
        }
    },
    // beforeDestroy() {
    //     window.top.removeEventListener('message', this.messageOfSelect)
    // },
    watch: {},
    methods: {
        async getPriceShow() { 
            const { data: res } = await this.$http.post(this.priceArgs.url, this.Qs.stringify(this.priceArgs))
            this.allowCostPrice = res.result
            this.getCustomColumnsList()
        },
        // 查询主界面的数据
        async getTableList() {
            this.loadingTable = true
            console.log('查询主界面的数据')
            const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/sale/collect/selectSaleHeadList.html', this.params)
            if (res.code != '0') {
                this.tableList = []
                this.total = 0
                this.summaries = {}
                return this.$message.error(res.message)
            }
            console.log(res.data)
            this.tableList = res.data.data
            this.total = res.data.total
            this.summaries = res.data.sum ? res.data.sum : {}
            this.loadingTable = false
        },
        // 接受子组件穿过的值， 接受自定义数组，  赋值更新表头给当前的界面
        changeChecked() {
            // this.tableHeaderList = tableHeaderList
        },
        // 查询可以自定义显示表头的数据
        async getCustomColumnsList() {
            console.log('查询可以自定义显示表头的数据')
            const { data: res } = await this.$post(
                "/erpnew/account/c/reada46ceb/common/selectNewColumnByFuncCode.html",
                { funcCode: 644 }
            );
            if (res.code != "0")
                return this.$confirm(res.message, "提示", {
                    confirmButtonText: "确定",
                    showCancelButton: false,
                    type: "error",
                });
            // 新接口直接返回数组（已按当前登录人保存的 sort 升序）；无 id 字段，用 prop 补 id 作为列表 key 与拖动标识
            this.checkboxList = (res.data || []).map((item, index) => {
                return Object.assign({}, item, { id: item.prop || index })
            })
            // 客户/商品维度列（需求#154）：与成本无关，清除可能误存的 allowCostPrice，避免被自定义列弹窗过滤不显示
            const dimProps = ['serviceUserName', 'customerEntryUserName', 'customerLevel', 'customerLabel', 'settlementCustomerName', 'isNewCustomerName', 'isNewShopName', 'customerStatus', 'productLabelName', 'productClassification', 'isScatterProductName', 'priceBandLabelName', 'isMaterialName', 'countTankStatsName', 'supplierName']
            // 固定展示列：单据类型/单据日期/仓库/客户/片区/商品/销售形式/数量/单价/总金额/业务员/审核时间/生产日期/单号/订单单号/单品备注
            // 固定列是页面写死的业务基础列，不参与自定义列排序/隐藏，也不出现在自定义列弹窗（即使接口/历史配置中登记过也一律剔除）。
            // 注意：不能依赖运行时 isShow 判定——维度列被勾选后 isShow 变 Y 会误当固定列剔除，故写死固定列清单
            // 固定列清单，仅保留页面确实存在的固定列（防止该列从 tableHeaderList 移除后仍影响判断）
            const validFixedShowProps = ['billTypeName', 'billDate', 'warehouseName', 'customerName', 'domainDesc', 'itemName', 'isLargessName', 'qtyFormat', 'priceFormat', 'totalAmt', 'salesmanName', 'recordedDateTime', 'productionDate', 'billNo', 'orderBillNo', 'detailRemark'].filter(p => this.tableHeaderList.some(t => t.prop === p))
            // 自定义列配置中混入的固定列一律剔除（固定列只由页面写死控制展示）
            this.checkboxList = this.checkboxList.filter(item => !validFixedShowProps.includes(item.prop))
            // 维度列清理 allowCostPrice，确保在自定义列弹窗可见可选
            this.checkboxList.forEach(item => {
                if (dimProps.includes(item.prop)) {
                    delete item.allowCostPrice
                }
            })
            // 重排 tableHeaderList：固定展示列保持原始顺序排在最前，其后按接口出参顺序排可自定义列
            let orderedList = this.tableHeaderList.filter(t => validFixedShowProps.includes(t.prop))
            this.checkboxList.forEach( (item) => {
                let find = this.tableHeaderList.find(t => t.prop == item.prop)
                if (find) {
                    orderedList.push(find)
                }
            });
            // 接口未返回的非固定列（本地兜底）追加到末尾
            this.tableHeaderList.forEach( (t) => {
                if (!orderedList.find(o => o.prop == t.prop)) {
                    orderedList.push(t)
                }
            });
            this.tableHeaderList = orderedList;
            // 需求#154：后端模板未登记的新列（客户/商品维度列）兜底加入自定义列配置，默认隐藏
            this.tableHeaderList.forEach( (items) => {
                let exist = this.checkboxList.find(item => item.prop == items.prop)
                if (!exist && !validFixedShowProps.includes(items.prop)) {
                    this.checkboxList.push({ prop: items.prop, label: items.label, isShow: 'N' })
                }
            });
            this.checkboxList.forEach( (item, index) => {
                this.tableHeaderList.forEach((items, indexs) => {
                    if(item.prop == items.prop) {
                        this.$set(this.checkboxList[index], 'label', items.label)
                        this.$set(this.tableHeaderList[indexs], 'isShow', item.isShow)
                        if(items.allowCostPrice) {
                            // this.$store.state.power.allowCostPrice
                            this.$set(this.checkboxList[index], 'allowCostPrice', this.allowCostPrice)
                            this.$set(this.tableHeaderList[indexs], 'allowCostPrice', this.allowCostPrice)
                        }
                    }
                })
            })
            
            // this.tableHeaderList.forEach( (item, index) => {
            //     this.checkboxList.forEach((items, indexs) => {
            //         if(item.prop === items.prop) {
            //             this.$set(this.tableHeaderList[index], 'isShow', items.isShow)
            //         }
            //     })
            // })

            // 兜底：同步完成后再次清理维度列的 allowCostPrice，确保弹窗可见（customizeColumns v-if="item.allowCostPrice != 'N'" 会过滤）
            this.checkboxList.forEach(item => {
                if (dimProps.includes(item.prop)) {
                    delete item.allowCostPrice
                }
            })
            // console.log(this.checkboxList)
        },
        // 表格下方的合计
        getSummaries(param) {
            const { columns } = param
            const sums = [];
            for (let key in this.summaries) {
                columns.forEach((column, index) => {
                    if (index == 1) {
                        sums[index] = '合计'
                        return
                    }
                    if (column.property == key) {
                        // sums[index] = this.summaries[key]
                        if(column.property == 'qtyFormat'){
                          let htmlText = <div style="cursor: pointer">
                                <span>{this.summaries[key]}</span>
                                <el-tooltip class="box-item" effect="light" content="合计包括销售数量、退货数量和还货数量，不包括换货数量" placement="top">
                                    <i class="iconfont icon-a-bangzhu2" style="color: #ff8940;"></i>
                                </el-tooltip>
                              </div>
                          sums[index] = htmlText
                        }else if(column.property == 'totalAmt') {
                          let htmlText = <div style="cursor: pointer">
                            <span>{this.summaries[key]}</span>
                            <el-tooltip class="box-item" effect="light" content="合计包括销售金额、退货金额和还货金额，不包括换货金额" placement="top">
                              <i class="iconfont icon-a-bangzhu2" style="color: #ff8940;"></i>
                            </el-tooltip>
                          </div>
                          sums[index] = htmlText
                        }else if(column.property == 'totalInvQty'){
                            sums[index] = this.summaries.totalInvQtyFormat
                        }else {
                          sums[index] = this.summaries[key]
                        }
                        return
                    }
                })
            }
            this.$nextTick(() => {
                this.$refs[this.tag].doLayout();
            })
            return sums
        },
        // 查询客户标签列表
        async getLabelData() {
            const { data: res } = await this.$http.post('/Account/pubLabelDefineVue/selectLabelList.html', this.Qs.stringify({ labelType: '001' }))
            if (res.code != 'success') return this.$message.error(res.message)
            res.result = JSON.parse(res.result)
            this.queryForm.label.list = JSON.parse(res.result.data).map(item => {
                item.text = item.labelDesc
                item.value = item.id
                return item
            })
            // 需求#154：商品类型（labelType=002）、价格带（labelType=003）
            const { data: res2 } = await this.$http.post('/Account/pubLabelDefineVue/selectLabelList.html', this.Qs.stringify({ labelType: '002' }))
            if (res2.code == 'success') {
                res2.result = JSON.parse(res2.result)
                this.queryForm.productLabelIds.list = JSON.parse(res2.result.data).map(item => {
                    item.text = item.labelDesc
                    item.value = item.id
                    return item
                })
            }
            const { data: res3 } = await this.$http.post('/Account/pubLabelDefineVue/selectLabelList.html', this.Qs.stringify({ labelType: '003' }))
            if (res3.code == 'success') {
                res3.result = JSON.parse(res3.result)
                this.queryForm.priceBandLabelId.list = JSON.parse(res3.result.data).map(item => {
                    item.text = item.labelDesc
                    item.value = item.id
                    return item
                })
            }
        },
        // 搜索条件 重置
        onReset() {
            this.$refs['queryFormRef'].resetFields()
        },
        // 条件查询按钮
        onSubmit() {
            console.log('details提交查询')
            for (let i in this.queryForm) {
                if (typeof this.queryForm[i].selected == 'object') {
                    if (i == 'billDate') {
                        if (this.queryForm[i].selected) {
                            this.$set(this.params, 'beginDate', this.queryForm[i].selected[0])
                            this.$set(this.params, 'endDate', this.queryForm[i].selected[1])
                        } else {
                            this.$set(this.params, 'beginDate', '')
                            this.$set(this.params, 'endDate', '')
                        }
                        continue
                    }
                    let tempArr = []
                    this.queryForm[i].selected.map(item => {
                        if (this.queryForm[i].valueIsObj) {
                            tempArr.push("'" + item.value + "'")
                        } else {
                            tempArr.push("'" + item + "'")
                        }
                    })
                    this.$set(this.params, this.queryForm[i].submitName, tempArr.join(','))
                } else {
                    this.$set(this.params, this.queryForm[i].submitName, this.queryForm[i].selected)
                }
            }
            this.params.page = 1
            this.getTableList()
            // window.top.postMessage({ code: 'success', data: this.params, tag: 'commodityDetails' }, '*')
        },
        // 查询条件中  选择商品
        productInputFocus() {
            this.$refs['productSelectRef'].blur()
            window.top.openDialog55('选择商品', '/Account/sys/common/productSelect.html?tag=SaleReportDimension&isFitterEnabled=N')
        },
        // 查询条件中  选择客户
        customerInputFocus() {
            this.$refs['customerSelectRef'].blur()
            window.top.openDialog55('选择客户', '/Account/sys/common/customerSelect.html?isFitterEnabled=N&tag=SaleReportDimensionCustomer')
        },
        // 显示 自定义头部  的弹框
        async getCustomColumns() {
            // 需求#154：先 await 刷新自定义列配置（含客户/商品维度列）再打开弹窗，避免弹窗使用旧 checkboxList
            await this.getCustomColumnsList()
            this.dialogVisible = true
            // let tempArr = [...this.customColumn]
            // this.$nextTick(() => {
            //     let element = this.$refs['customColumns']
            //     element.loading = false
            //     element.setCustomcolumns(tempArr)
            // })
        },
        // 关闭 并 调取 修改自定义接口
        dialogClose(info) {
            // console.log('tempCheckBoxList: ', info.tempCheckBoxList)
            // return
            if(!info.isSubmit){
                this.dialogVisible = false
                return
            }
            console.log(this.checkboxList)
            this.setCustomColumns(info.tempCheckBoxList)
        },
        async setCustomColumns(tempCheckBoxList) {
            // 以弹窗确认时的数组顺序提交，每项写入 sort（与数组下标一致），供新接口按用户顺序回显
            const info = (tempCheckBoxList || []).map((item, index) => {
                return Object.assign({}, item, { sort: index })
            })
            const { data: res } = await this.$http.post('/Account/customerColumnDefineVue/saveColAndAuthByFuncCode.html', this.Qs.stringify({
                funcCode: 644,
                customSetInfo: JSON.stringify(info)
            }))
            if (res.code != 'success') return this.$message.error(res.message)
            this.$message.success(res.message)
            this.dialogVisible = false
            this.getCustomColumnsList()
        },
        // 导出
        exportExcel(flag) {
            this.exportTableExcel(flag)
        },
        exportTableExcel(flag) {
            let obj = { ...this.params }
            delete obj.url
            let exportExcelUrl = '/erpnew/account/c/reada46ceb/sale/collect/saleDetailQueryExcelReport.html'
            let tempArr = []
            this.tableHeaderList.forEach(item => {
                if(item.allowCostPrice == 'N') return
                if (item.isShow == 'Y'){
                    tempArr.push({
                    label: item.label,
                    prop: item.prop
                })
                }
            })
            // this.checkboxList.forEach(item => {
            //     if (item.isShow == 'Y') {
            //         tempArr.push({
            //             label: item.label,
            //             prop: item.prop
            //         })
            //     }
            // })
            console.log(tempArr)
            if(flag == 'Y'){
              obj.isSplit = 'Y'
            }
            exportExcelCommonForVue(obj, tempArr, exportExcelUrl)
        },
        handleCommand(command) {
            if(command == 'A') {
                this.exportExcel()
            } else if(command == 'B') {
                this.exportExcel('Y')
            } else if(command == 'C') {
                this.kisExportExcel()
            }
        },
        kisExportExcel() {
            let obj = JSON.parse(JSON.stringify(this.params))
            delete obj.url
            exportExcelCommonForVue(obj, [], '/erpnew/account/c/reada46ceb/sale/collect/saleItemDetailSplitExcelReport.html')
            console.log(obj)

        },
        // 切换大类
        brandChange(val) {
            console.log(val)
            let str = val.map(item => "'" + item.value + "'").join(',')
            this.queryForm.brandType.request.params['brandID'] = str
            this.queryForm.brandType.isReSearch = true
        },
        handleSizeChange(val) {
            this.params.size = val
            this.getTableList()
        },
        handleCurrentChange(val) {
            this.params.page = val
            this.getTableList()
        },
        // 转详情
        jumpDetails(row) {
            console.log(row.billType,row.billNo)
            let width = window.top.document.browser.availiframeWidth.value
            let height = window.top.document.browser.availiframeHeight.value
            if(row.billType == 'FX') {
                top.addPanel('访销单详情', `/yunsierp3/index.html#/order/fangxiaoOrder?billNo=${ row.billNo }&billType=${row.billType}`, width, height, true)
            } else {
                top.addPanel('单据详情', `/yunsierp3/index.html#/docket/docketDetails?billType=${ row.billType }&billNo=${ row.billNo }`,width, height, true)
            }
        },
           // 去重
        resArr(arr) {
            return arr.filter((item, index) => arr.findIndex(i => i.value === item.value) === index);
        },
        queryQueryDataTemp(){
            let tempData = top.getQueryDataTemp(this.timestemp)
            console.log('getQueryDataTemp', top.getQueryDataTemp)
            console.log('tempData', tempData)
            if(tempData){
                console.log('tempData', tempData)
                if(tempData.timestemp == this.timestemp)  {
                    for( let i in this.queryForm ) {
                        Object.keys(tempData).map((key)=>{
                            if(this.queryForm[i].submitName === tempData[key].submitName) {
                                if(this.queryForm[i].submitName == 'billDate' || this.queryForm[i].submitName == 'customerID' || this.queryForm[i].submitName == 'itemID' ) {
                                    this.queryForm[i] = tempData[key]
                                    return
                                }
                                // this.queryForm[i].selected instanceof Array && this.queryForm[i].list instanceof Array
                                // tempData[key].selected instanceof Array && tempData[key].list instanceof Array
                                if(this.queryForm[i].selected instanceof Array && this.queryForm[i].list instanceof Array) {
                                    this.queryForm[i].selected = tempData[key].selected
                                    let arr = this.queryForm[i].list
                                    arr.unshift(...tempData[key].selected)
                                    this.queryForm[i].list = this.resArr(arr)
                                    return
                                } else {
                                    this.queryForm[i] = tempData[key]
                                } 
                            }
                        }) 
                    }
                    console.log(this.queryForm)
                }
                this.onSubmit()
            }else {
                this.onSubmit()
            }
        },
        // 接受上级页面
        messageOfSelect(e) {
            setTimeout(() => {
                let { data: res } = e
                console.log(res)
                if(res.tag === 'commodityDetails' && res.data.timestemp == this.timestemp)  {
                    for( let i in this.queryForm ) {
                        Object.keys(res.data).map((key)=>{
                            if(this.queryForm[i].submitName === res.data[key].submitName) {
                                if(this.queryForm[i].submitName == 'billDate' || this.queryForm[i].submitName == 'customerID' || this.queryForm[i].submitName == 'itemID' ) {
                                    this.queryForm[i] = res.data[key]
                                    return
                                }
                                // this.queryForm[i].selected instanceof Array && this.queryForm[i].list instanceof Array
                                // res.data[key].selected instanceof Array && res.data[key].list instanceof Array
                                if(this.queryForm[i].selected instanceof Array && this.queryForm[i].list instanceof Array) {
                                    this.queryForm[i].selected = res.data[key].selected
                                    let arr = this.queryForm[i].list
                                    arr.unshift(...res.data[key].selected)
                                    this.queryForm[i].list = this.resArr(arr)
                                    return
                                } else {
                                    this.queryForm[i] = res.data[key]
                                } 
                            }
                        }) 
                    }
                    console.log(this.queryForm)
                }
                this.onSubmit()
            },1000)
        },
        messageOfSelectoneself(e) {
            let { data: res } = e
            if (res.tag == 'SaleReportDimension') {
                if (res.code != 'success') return false
                console.log('商品')
                // console.log(this.$refs['productSelectRef'])
                this.$set(this.queryForm.product, 'list', res.data)
                // this.queryForm.product.selected = res.data.map(item => (item.value))
                this.queryForm.product.selected = res.data
                top.layer.closeAll('iframe')
            } else if (res.tag == 'SaleReportDimensionCustomer') {
                if (res.code != 'success') return false
                console.log('客户')
                // console.log(this.$refs['productSelectRef'])
                this.$set(this.queryForm.customer, 'list', res.data)
                // this.queryForm.product.selected = res.data.map(item => (item.value))
                this.queryForm.customer.selected = res.data
                top.layer.closeAll('iframe')
            }
        }
    }
};
</script>
<style type="text/css" src="@/assets/font/pcFont/iconfont.css"></style>
<style scoped lang="less">
#tab {
    .isCollapse {
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        border: 1px #DCDFE6 solid;
        cursor: pointer;
        background-color: rgba(83, 168, 255, 0.1);
        color: #409EFF;
    }

    /deep/.aside-box {
        height: 100%;
        overflow: hidden;

        .select_multiple {
            ::v-deep .el-select__tags {
                max-height: 80px;
                overflow-y: auto;
                overflow-x: hidden;
            }
        }

        .el-card {
            height: calc(100% - 2px);
        }

        .el-card__header {
            padding: 12px;
        }

        .el-card__body {
            padding: 0 0 6px;
            height: calc(100% - 6px);
            position: relative;
        }

        .el-tabs {
            height: 100%;
        }

        .el-tabs__content {
            // padding: 0 6px;
            height: calc(100% - 41px - 15px);
        }

        .el-tab-pane {
            height: 100%;
        }

        .el-form {
            height: 100%;

            .el-form-item {
                padding: 0 12px 0 0;
            }
        }

        .el-scrollbar {
            height: calc(100% - 40px);
        }

        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        .el-scrollbar__bar {
            z-index: 999;
        }

        .table-header {
            height: 50px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: 0 12px;

            p {
                font-size: 17px;
                font-weight: bolder;
            }
        }

        .table-list {
            padding: 0 12px;

            .item {
                height: 40px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;

                p {
                    font-size: 14px;
                    flex: 1;
                    cursor: pointer;
                    color: #333;

                    &.active {
                        color: #409EFF;
                    }
                }
            }
        }
    }

    /deep/.product-dialog {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        top: 50%;
        transform: translateY(-50%);
    }

    /deep/ .el-table--scrollable-x .el-table__body-wrapper {
        z-index: 2;
    }

    /deep/.main-box {
        padding: 0 20px;

        .tabs-card {
            height: calc(100% - 40px);

            .el-tabs__item {
                height: 32px;
                line-height: 32px;
            }

            .el-tabs__content {
                padding: 0 12px;
                height: calc(100% - 33px);

                .el-tab-pane {
                    height: calc(100% - 56px - 24px);
                }
            }
        }

        .el-card {
            margin: 12px 0;
        }

        .el-card__body {
            padding: 6px 12px;

            .el-form-item {
                margin-bottom: 0;
            }
        }

        // .el-pagination {
        //     margin-top: 16px;
        // }
    }
}
.tree {
    min-height: 300px;
}
</style>